"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatClock = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secsSansMins = seconds - mins * 60;
    return `${mins.toString().length === 1
        ? `0${mins}`
        : mins}:${secsSansMins.toString().length === 1
        ? `0${secsSansMins}`
        : secsSansMins}`;
};
//# sourceMappingURL=formatClock.js.map